// Định dạng và tiện ích dùng chung của giao diện workspace (chuyển nguyên từ screens/Main.tsx).
import { isRateLimited, SwChatApiError } from '@swchat/client-sdk';

export const timeFmt = new Intl.DateTimeFormat('vi-VN', { hour: '2-digit', minute: '2-digit' });
export const dayFmt = new Intl.DateTimeFormat('vi-VN', { weekday: 'long', day: 'numeric', month: 'numeric', year: 'numeric' });
const shortDayFmt = new Intl.DateTimeFormat('vi-VN', { day: '2-digit', month: '2-digit' });
/** W2.3: ngày gửi file trong tab Tệp (đủ năm, kèm giờ). */
export const fileDateFmt = new Intl.DateTimeFormat('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

/** Hàng cảm xúc nhanh: đầu bộ mặc định của Telegram; muốn emoji khác bấm "+" mở bảng đầy đủ. */
export const REACTIONS = ['👍', '👎', '❤️', '🔥', '🥰', '👏', '😁', '🤔'];

/** Tên hiển thị trên giao diện (tên mã dự án vẫn là SW Chat; tiêu đề tab/thông báo giữ `APP_TITLE`). */
export const BRAND = '7w Chat';

/** Giờ nếu là hôm nay, ngược lại ngày/tháng. */
export function shortTime(ts: number) {
  return new Date(ts).toDateString() === new Date().toDateString() ? timeFmt.format(ts) : shortDayFmt.format(ts);
}

/** Lỗi gửi tin → thông báo; 429 (F3) có thông báo riêng, tin vẫn ở trạng thái lỗi với nút "Gửi lại". */
export function sendErrorText(e: unknown): string {
  if (isRateLimited(e)) return 'Gửi quá nhanh — tin chưa được gửi, bấm "Gửi lại" sau ít giây';
  return e instanceof Error ? e.message : String(e);
}

/**
 * Lỗi tải file → thông báo; 404 = không còn là thành viên (đã rời / bị xóa) hoặc file đã bị xóa; 403 = server từ chối
 * quyền đọc file (W2.3 — tab Tệp liệt kê cả file cũ mà thiết bị còn giữ).
 */
export function downloadError(e: unknown): string {
  return e instanceof SwChatApiError && (e.status === 404 || e.status === 403) ? 'Không còn quyền tải' : 'Không tải được file';
}

export const errorText = (e: unknown) => (e instanceof Error ? e.message : String(e));

/** Lưu Blob về máy qua `a[download]` (URL tạm, thu hồi ngay sau khi trình duyệt nhận). */
export function saveBlob(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
